import sensoryReportList from "@/components/page/sensory2/sensory-report/sensoryReportList";
import sensoryReportDetail from "@/components/page/sensory2/sensory-report/sensoryReportDetail";

export default [
    {
        name: "processSensoryReportList",
        path: '/processSensoryReport',
        meta: { title: 'sensory.process.report.title' },
        component: sensoryReportList
    },
    {
        name: "newProcessSensoryReport",
        path: '/processSensoryReport-add',
        meta: { title: 'common.edit' },
        component: sensoryReportDetail
    },
    {
        name: "processSensoryReportDetail",
        path: '/processSensoryReport-edit',
        component: sensoryReportDetail,
        meta: { title: 'common.edit' },
    },
]
